﻿<script setup lang="ts">
    import { provide } from 'vue';
    import { imageLibraryProvideName, type ImageLibraryProvide } from './types';
    import { setupImageLibrary } from '@shared/components/Images/ImageLibrary';
    import ImageLibrary from './ImageLibrary.vue';

    const imageLibrary = setupImageLibrary();
    provide<ImageLibraryProvide>(imageLibraryProvideName, {
        currentState: imageLibrary.currentState,
        newSrc: imageLibrary.newSrc,
        insert: imageLibrary.insert,
        load: imageLibrary.load,
        toggleShowLibrary: imageLibrary.toggleShowLibrary,
        isStandalone: true,
    });
</script>

<template>
    <ImageLibrary class="image-library-root" />
</template>

<style>
    .image-library-root .items-list-cards {
        padding-right: 0;
        padding-left: 0;
    }

    .image-library-root .file-drop-area {
        margin: var(--ug-spacing-lg) 0 0 !important;
    }
</style>
